var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LLTabs2',{attrs:{"items":_vm.tabs,"aria-label":_vm.$t('dashboard.tabs.aria')},on:{"change":_vm.emitChange},model:{value:(_vm.internalTab),callback:function ($$v) {_vm.internalTab=$$v},expression:"internalTab"}})
}
var staticRenderFns = []

export { render, staticRenderFns }